export function normalizeEmail(email: string | null | undefined): string {
  return (email || '').trim().toLowerCase();
}
